import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { handleChangeEvent, handlePatch } from '../../../utils/AxiosUtil';
import * as enums from '../../../utils/EnumMapping';
import { toDateFormat, trimSpaces } from '../../../utils/Util';
import ErrorAwareAmountField from '../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareSelectField from '../../common/inputfields/ErrorAwareSelectField';
import ErrorAwareTextField from '../../common/inputfields/ErrorAwareTextField';
import MyAutocomplete from '../../common/inputfields/MyAutocomplete';

class ModifyCorrection extends Component {
    state = {
        selectedPartner: this.props.selectedPartner ? this.props.selectedPartner : {},
        selectedAmountType: enums.getObjectByValue(enums.correctionTypes, this.getCorrectionType(this.props.row.balanceRowType)),
        prevAmountType: enums.getObjectByValue(enums.correctionTypes, this.getCorrectionType(this.props.row.balanceRowType)),
        amount: this.props.row.amount,
        date: new Date(this.props.row.date),
        comment: this.props.row.comment,
        errors: new Map()
    }

    getCorrectionType(balanceRowType) {
        if ("CORRECTION_FIX" === balanceRowType) {
            return "FIX";
        } else {
            return "MODIFY"
        }
    }
    componentDidMount() {
        console.log(this.props);
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/correction';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "partnerId": this.getPartnerId(),
            "partnerType": this.getPartnerType(),
            "amount": trimSpaces(this.state.amount),
            "amountType": this.state.selectedAmountType.value,
            "date": toDateFormat(this.state.date),
            "comment": this.state.comment,
        };
        handlePatch(path, requestObject, this);
    };

    getPartnerId = () => {
        if (this.state.selectedPartner && this.state.selectedPartner.value) {
            return this.state.selectedPartner.value.partnerId;
        } else {
            return null;
        }
    }

    getPartnerType = () => {
        if (this.state.selectedPartner && this.state.selectedPartner.value) {
            return this.state.selectedPartner.value.partnerType;
        } else {
            return 'CASH';
        }
    }

    promisePartnerOptions = async () => {
        const response = await axios.get('/api/balance')
        const renamedPartners = [];
        response.data.map((partner) =>
            renamedPartners.push({
                label: enums.getLabel(enums.partnerTypes, partner.partnerType) + ' - ' + partner.partnerName,
                value: partner,
            }));
        console.log(renamedPartners);
        return renamedPartners;
    };

    handlePartnerSelected = (e, v) => {
        console.log(v);
        if (v) {
            this.setState({ selectedPartner: v })
        } else {
            this.setState({ selectedPartner: {} })
        }
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    {this.props.row.rowType === 'CASH' ?
                        <div className='input-group'>
                            <ErrorAwareTextField
                                name="cash"
                                id="cash"
                                label=""
                                value="Készpénz"
                                disabled={true}
                            />
                        </div>
                        :
                        <div className='input-group'>
                            <MyAutocomplete
                                value={this.state.selectedPartner}
                                getOptions={this.promisePartnerOptions}
                                onChange={this.handlePartnerSelected}
                                label={'Partner'}
                                disabled={true}
                            />
                        </div>}
                    <div className='input-group'>
                        <ErrorAwareSelectField
                            labelId="amount-type-label"
                            id="amount-type-label"
                            name="selectedAmountType"
                            label="Típus"
                            errors={this.state.errors}
                            value={this.state.selectedAmountType}
                            prevValue={this.state.prevAmountType}
                            onChange={e => handleChangeEvent(e, this)}
                            options={enums.correctionTypes}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            id="amount"
                            name="amount"
                            label="Összeg"
                            value={this.state.amount}
                            prevValue={this.props.row.amount}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            name="date"
                            label="Dátum"
                            errors={this.state.errors}
                            value={this.state.date}
                            prevValue={this.props.row.date}
                            onChange={event => this.setState({ date: event })} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            value={this.state.comment}
                            prevValue={this.props.row.comment}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Módosít
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyCorrection);
